import { render, staticRenderFns } from "./SnackBarMessage.vue?vue&type=template&id=74d34550&"
import script from "./SnackBarMessage.vue?vue&type=script&lang=js&"
export * from "./SnackBarMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports